module.exports = __webpack_public_path__ + "static/rcc-most-common-ar-graph-mobile-f203de60468c82e05a68f8848cecba03.png";